import React, { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Terms from "../pages/Terms/index";
import EventProfile from "../pages/event/index";
import { ProtectedAuthRoute, ProtectedRoute } from "./protectedRoute";
import Loader from "../components/loader";
import LandingPage from "../components/LandingPage/index";
import Contact from "../components/contacts/Contact";
import MemberInvite from "../components/MemberInvite/MemberInvite";
import Navbar from "../components/navbar";

const BuyAdSpace = lazy(() => import("../pages/buyAdSpaceComp"));
const StepFormPage = lazy(() => import("../pages/StepFormPage"));
const CardSelectionPage = lazy(() => import("../pages/CardSelectionPage"));
const Login = lazy(() => import("../pages/login/index"));
const History = lazy(() => import("../pages/event/bookedEvents"));
const MagazinePDF = lazy(() => import("../pages/pdfBook"));
const HomePage = lazy(() => import("../components/home/index"));
const HostProfile = lazy(() => import("../pages/hostView"));
const ForgetPassword = lazy(() => import("../pages/login/forgetPassword"));
const NotFound = lazy(() => import("../pages/404"));

const Index = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <React.Suspense fallback={<Loader />}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/onBoarding"
            element={
              <ProtectedAuthRoute>
                <CardSelectionPage />
              </ProtectedAuthRoute>
            }
          />
          <Route
            path="/dashboard*"
            element={
              <ProtectedRoute>
                <EventProfile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <History />
              </ProtectedRoute>
            }
          />

          <Route
            path="/host"
            element={
              <ProtectedRoute>
                <HostProfile />
              </ProtectedRoute>
            }
          />

          <Route path="/signup" element={<StepFormPage />} />
          <Route
            path="/member-invitation"
            element={
              <div>
                <Navbar user={user} />
                <MemberInvite />
              </div>
            }
          />

          <Route path="/terms" element={<Terms />} />
          <Route path="/view-magazine/:title" element={<MagazinePDF />} />
          <Route
            path="/"
            element={
              <ProtectedAuthRoute>
                <LandingPage />
              </ProtectedAuthRoute>
            }
          />
          <Route
            path="/buy-adspace"
            element={
              <ProtectedAuthRoute>
                <BuyAdSpace />
              </ProtectedAuthRoute>
            }
          />
          <Route
            path="/login"
            element={
              <ProtectedAuthRoute>
                <Login />
              </ProtectedAuthRoute>
            }
          />

          <Route
            path="/forget-password"
            element={
              <ProtectedAuthRoute>
                <ForgetPassword />
              </ProtectedAuthRoute>
            }
          />
          {/* Catch-all route for 404 */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </BrowserRouter>
    </React.Suspense>
  );
};

export default Index;
